module.exports = __webpack_public_path__ + "static/media/logo-footer-bg.132ab80e.svg";